import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {GuidService} from "../../services/guid.service";
import {NgForOf, NgIf} from "@angular/common";
import {ServerDetectService} from "../../services/server-detect.service";

@Component({
  selector: 'file-input',
  standalone: true,
  templateUrl: './file-input.html',
  styleUrl: './file-input.scss',
  imports: [TranslateModule, NgIf, NgForOf]
})
export class FileInput implements OnInit {
  files: File[];
  @Input() disabled: boolean;
  @Input() multiple: boolean = true;
  @Output() onChange: EventEmitter<File[]> = new EventEmitter();
  inputId: string = GuidService.newId();

  constructor(private serverDetectService: ServerDetectService) {

  }

  ngOnInit(): void {
    if(this.serverDetectService.isServer())return;
    const el = document.getElementById(this.inputId);
    if (!el) return;
    el.addEventListener('dragenter', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    el.addEventListener('dragover', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    el.addEventListener('drop', (e) => this.handleDragIn(e));
  }

  handleDragIn(e: DragEvent) {
    e.preventDefault()
    e.stopPropagation()
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      this.fileChanged(files);
    }
  }

  triggerClick() {
    const el = document.getElementById(this.inputId);
    el.click();
  }

  sendFiles() {
    this.onChange.emit(this.files);
  }

  onFileChange(ev: Event) {
    const input = ev.target as HTMLInputElement;
    this.fileChanged(input.files);
  }

  fileChanged(files: FileList) {
    const res: File[] = [];
    Array.from(files).forEach(element => {
      res.push(element);
    });
    this.files = res;
    this.sendFiles();
  }
}
